export default [
	{
		settings: true,
		text: "ID",
		value: "broker_id",
		func: true,
		valueFilter: 'filter_broker_id',
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Broker name",
		value: "broker",
		func: true,
		valueFilter: 'filter_broker',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "MC#",
		value: "mc",
		func: true,
		valueFilter: 'filter_mc',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Mailing address",
		value: "pa_street_1",
		func: true,
		valueFilter: 'filter_address',
		model: { value: 'note' },
		sortable: true
	},
	{
		settings: true,
		text: "Email",
		value: "email_address",
		func: true,
		valueFilter: 'filter_email_address',
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Phone",
		value: "local_phone",
		func: true,
		valueFilter: 'filter_local_phone',
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		width: '100px',
		buttons: [
			{
				perm: { or: [ 9 ] },
				value: 'edit',
				text: 'Edit broker',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete broker',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		]
	},
];

